<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 用户管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>权限管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="名称" class="handle-input mr10"></el-input>
				&nbsp;
				<el-select v-model="query.roleId" placeholder="请选择角色" filterable>
					<el-option key="" label="请选择角色" value=""></el-option>
					<el-option key=1 label="企业管理员" :value=1></el-option>
					<el-option key=2 label="部门管理员" :value=2></el-option>
					<el-option key=3 label="一般用户" :value=3></el-option>
				</el-select>
				&nbsp;
				<el-select v-model="query.departmentId" placeholder="请选择部门" filterable>
					<el-option key="" label="请选择部门" value=""></el-option>
					<el-option v-for="item in departmentKv" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="roleId" label="角色" :formatter = "roleFormat"></el-table-column>
				<el-table-column prop="departmentId" label="所属部门" :formatter = "departmentFormat"></el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

		<el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="60%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="9">
						<el-form-item label="名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="角色" prop="roleId">
							<el-select v-model="form.roleId" placeholder="请选择角色" @change="roleChange">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option key=1 label="企业管理员" :value=1></el-option>
								<el-option key=2 label="部门管理员" :value=2></el-option>
								<el-option key=3 label="一般用户" :value=3></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="所属部门" prop="departmentId" v-if="departmentVisible">
							<el-select v-model="form.departmentId" placeholder="请选择部门">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option v-for="item in departmentKv" :key='item.key' :label='item.value' :value='item.key'></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<div style="margin-left:50px;margin-right:50px;">
					<v-AuthoritySet ref="authorityTree"></v-AuthoritySet>
				</div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchUserAuthorityData, saveUserAuthority, deleteUserAuthority, getUserAuthority, 
getEnumValueKV, getPostionKV, getAuthorityRouteTreeData, getCompanyAuthority, getFirstDepartment } from '../../../api/index';
import vAuthoritySet from '../../common/AuthoritySet.vue';
export default {
    name: 'user-authority',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			title:"",
			rules: {
				name: [{ required: true, message: '请输入权限名称', trigger: 'blur' }],
                roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }]
            },
			postionKV:[],
			groupKV:[],
			groupKV2:[],
			loadTree:false,
			multipleSelection:[],
			treeDatasource:[],
			applyCompanyKeys:[],
			controll:{},
			departmentKv:[],
			departmentVisible:true
        };
    },
    created() {
		this.controll = getControll("user-authority");
        this.getData();
		this.getRouteTreeData();
		this.getOwnCompanyAuthority();
		this.getPostion();
		this.getDepartments();
    },
	components: {
        vAuthoritySet
    },
    methods: {
		getDepartments() {
			getFirstDepartment().then(res => {
				if (res.code == 0 ) {
					this.departmentKv = []
					for(var i = 0; i < res.data.length; i++) {
						let item = res.data[i];
						this.departmentKv.push({"key":Number(item.id),"value":item.name})
					}
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			})
		},
		roleChange(val) {
			this.departmentVisible = (val > 1)
		},
		getPostion() {
			getPostionKV().then(res => { 
				if (res.code == 0 ) {
					this.postionKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
		//获取用户权限数据
        getData() {
            fetchUserAuthorityData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		// 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteUserAuthority([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		// 获取树形结构数据
        getRouteTreeData() {
            getAuthorityRouteTreeData().then(res => { 
				if (res.code == 0 ) {
					this.treeDatasource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		getOwnCompanyAuthority() {
			getCompanyAuthority().then(res => { 
				if (res.code == 0 ) {
					this.applyCompanyKeys = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
		roleFormat(row, column, cellValue) {
			if (cellValue === 1) {
				return '企业管理员';
			} else if (cellValue === 2){
				return '部门管理员';
			} else {
				return '一般用户';
			}
		},
		departmentFormat(row, column, cellValue) {
			let index = this.departmentKv.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.departmentKv[index].value;
		},		
		postionFormat(row, column, cellValue) {
			let index = this.postionKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.postionKV[index].value;
		},
		//获取枚举
		onChangeGroupType(value) {
			this.groupTypeChange(value, 0);
		},
		onChangeGroupType2(value) {
			this.groupTypeChange(value, 1);
		},
		groupTypeChange(value, type) {
			if (type == 0) {
				this.groupKV = [];
			} else {
				this.groupKV2 = [];
			}
			if (!value) {
				return;
			}
			getEnumValueKV(value).then(res => {
				if (res.code == 0 ) {
					if (type == 0) {
						this.groupKV = res.data;
					} else {
						this.groupKV2 = res.data;
					}
				} else {
					this.$message.error("获取分组失败！" + res.message);
				}
			});
		},
		//添加操作
		handleAdd() {
			this.form = {};
			this.groupKV = [];
			this.title = "添加新纪录";
			this.editVisible = true;
			this.$nextTick(()=>{
				this.$refs.authorityTree.setDatasource(this.treeDatasource, [], this.applyCompanyKeys);
			});
		},
        // 编辑操作
        handleEdit(index, row) {
			this.title = "编辑";
			getUserAuthority(row.id).then(res => {
				if (res.code == 0) {
					this.onChangeGroupType2(res.data.postionId);
					this.form = res.data;
					this.departmentVisible = (this.form["roleId"] > 1)
					this.editVisible = true;
					let checkedKeys = this.form.authority?JSON.parse(this.form.authority):[];
					this.$nextTick(()=>{
						this.$refs.authorityTree.setDatasource(this.treeDatasource, checkedKeys, this.applyCompanyKeys);
					});
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let checkedKeys = this.$refs.authorityTree.getCheckedKeys();
					if (this.form["roleId"] == 1) {
						this.form["departmentId"] = undefined;
					}
					this.form["authority"] = JSON.stringify(checkedKeys);
					saveUserAuthority(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
